import * as XLSX from 'xlsx'

type EveryThingButNull = string | number | undefined | boolean
type DataSheet = Record<string, EveryThingButNull>

export const exportWorkbook = ({
  dataSheets,
  filename,
  colHeadersLabel,
  colWidths,
  rowHeight,
}: {
  dataSheets: Record<string, Array<DataSheet>>
  filename: string
  colHeadersLabel?: Record<keyof DataSheet, string>
  colWidths?: Record<keyof Record<keyof DataSheet, string> | keyof DataSheet, number>
  rowHeight?: number
}) => {
  const workbook = XLSX.utils.book_new()
  Object.entries(dataSheets).forEach(([sheetName, sheetData]) => {
    const sheetDataUpdatedHeadersLabel = !colHeadersLabel
      ? [...sheetData]
      : [...sheetData].map((data) =>
          Object.entries(data).reduce((list, [colHeaderName, colValue]) => {
            const newColHeaderName = colHeadersLabel[colHeaderName]
            return { ...list, [newColHeaderName?.length ? newColHeaderName : colHeaderName]: colValue }
          }, {} as DataSheet),
        )

    const hasData = sheetDataUpdatedHeadersLabel.length > 0
    let workbookSheet: XLSX.WorkSheet

    if (!hasData && colHeadersLabel) {
      // Create sheet with only headers when data is empty
      const translatedHeaders = Object.values(colHeadersLabel)
      workbookSheet = XLSX.utils.aoa_to_sheet([translatedHeaders])

      // Apply column widths
      if (colWidths) {
        translatedHeaders.forEach((header, index) => {
          const COL_WIDTH = (colWidths as Record<string, number>)[header] ?? 50
          workbookSheet['!cols'] = workbookSheet['!cols'] ?? []
          workbookSheet['!cols'][index] = workbookSheet['!cols'][index] ?? { wch: 8 }
          workbookSheet['!cols'][index]!.wpx = COL_WIDTH
        })
      }
    } else {
      // Normal flow with data
      workbookSheet = XLSX.utils.json_to_sheet(sheetDataUpdatedHeadersLabel)

      if (colWidths && sheetDataUpdatedHeadersLabel[0]) {
        Object.keys(sheetDataUpdatedHeadersLabel[0]).forEach((key, index) => {
          const COL_WIDTH = colWidths[key] ?? 50
          const COL_INDEX = index
          workbookSheet['!cols'] = workbookSheet['!cols'] ?? []
          workbookSheet['!cols'][COL_INDEX] = workbookSheet['!cols'][COL_INDEX] ?? { wch: 8 }

          workbookSheet['!cols'][COL_INDEX]!.wpx = COL_WIDTH
        })
      }

      // Apply row heights
      Object.keys(sheetDataUpdatedHeadersLabel).forEach((_, index) => {
        if (index > 0) {
          const ROW_HEIGHT = rowHeight ?? 30
          const ROW_INDEX = index
          workbookSheet['!rows'] = workbookSheet['!rows'] ?? []
          workbookSheet['!rows'][ROW_INDEX] = workbookSheet['!rows'][ROW_INDEX] ?? { hpx: ROW_HEIGHT }

          workbookSheet['!rows'][ROW_INDEX]!.hpx = ROW_HEIGHT
        }
      })
    }

    XLSX.utils.book_append_sheet(workbook, workbookSheet, sheetName.replaceAll('/', '-'))
  })
  XLSX.writeFile(workbook, `${filename}.xlsx`, { Props: { Author: 'Curecall' } })
}
